import { FieldArray } from "formik";
import {
  CardHeader,
  CardBody,
  Button,
  Row,
  Col,
  FormGroup,
  Input,
  UncontrolledTooltip,
  Label,
} from "reactstrap";
import SelectField from "../../Utils/SelectField";
import InputField from "../../Utils/InputField";
import { LabelText } from "../../Utils/Input";
import { Link } from "react-router-dom";
import { removeRowsFromGrantsAndCharges } from "./constants/checkEmptyFields";
import {
  grantsAndChargesHandle,
  handleGrantsAndChargesRecurringFrequencyAndUsageOptions,
  handleGrantsAndChargesResourceValueAndUsageFields,
  handleInfiniteForGrantsAndCharges,
} from "./constants/GrantsAndRecurringFunctions";
import {
  CycleAlignmentOption,
  GrantsValidityEnd,
  SubscriptionEndsOnOptions,
  SubscriptionStartsOnOptions,
  TimePeriodGrantOptions,
  ValidityStartsOnOptions,
  recurringGrantFrequencyOptions,
} from "./constants/initialValues";
import {
  handleGrantsRecurringOverride,
  handleRolloverPriorityState,
  handleRolloverState,
} from "./constants/displayInfinite";
import { useContext } from "react";
import { CreateOfferContext } from "./context";
import { tabChange } from "../../Utils/SetDefaultRowData";

export default function GrantsRecurring({ pushRef }) {
  const {
    values,
    errors,
    isEdit,
    isSubscribed,
    handleProrateState,
    touched,
    setTouched,
    handleChange,
    prorateState,
    overrideStateRecurring,
    resourceData,
    grantResourceOptions,
    setFieldValue,
    setFieldTouched,
    infiniteOptions,
    disableValidityInGrantRecurring,
    setDisableValidityInGrantRecurring,
    isEmptyorInvalidFieldForGrantsAndCharges,
    isCreate,
    sectionRefs,
    activeTab,
    setActiveTab,
  } = useContext(CreateOfferContext);
  return (
    <FieldArray name="recurringGrants">
      {({ push, remove }) => {
        pushRef.current = push;
        return (
          <div className="live-preview">
            {values?.grants?.length > 0 &&
            values?.recurringGrants?.length === 0 ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ marginTop: "120px" }}
              >
                {isSubscribed ? (
                  <div className="text-center mb-2">
                    There are no Grants available for this offer.
                  </div>
                ) : (
                  <div className="text-center mb-2">
                    There are no Grants available for this offer, Add a Grant to
                    proceed.
                  </div>
                )}
              </div>
            ) : (
              values?.recurringGrants?.map((val, index) => {
                const keyIndex = values?.recurringGrants?.length - (index + 1);
                const grantRef =
                  sectionRefs.current[`recurringGrants${keyIndex + 1}`];
                return (
                  <div
                    key={keyIndex}
                    className="border border-opacity-50 rounded-0 mb-3"
                    ref={grantRef}
                  >
                    <Row className="mb-0 px-3 pt-3">
                      <Col
                        xs={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <h3 className="card-title mb-0">
                          Grant {keyIndex > 0 ? keyIndex + 1 : ""}
                        </h3>
                        {!isSubscribed && (
                          <div>
                            <Link
                              to="#"
                              className="link-primary me-2"
                              onClick={() => {
                                const clonedGrant = {
                                  ...values.recurringGrants?.[keyIndex],
                                };
                                !isEmptyorInvalidFieldForGrantsAndCharges(
                                  keyIndex,
                                  values.recurringGrants
                                ) && push(clonedGrant);
                              }}
                            >
                              <i
                                data-testid="clone"
                                className="ri-file-copy-line"
                              ></i>
                            </Link>
                            <Link
                              to="#"
                              className="link-danger"
                              onClick={() => {
                                remove(keyIndex);
                                keyIndex === 0 &&
                                  tabChange("1", activeTab, setActiveTab);
                              }}
                            >
                              <i
                                data-testid="delete"
                                className="ri-delete-bin-5-line"
                              ></i>
                            </Link>
                          </div>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3 px-3 pt-3">
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <FormGroup>
                          <Label
                            htmlFor={`recurringGrants[${keyIndex}].recurringFrequency`}
                          >
                            Recurring Frequency
                          </Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].recurringFrequency`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringGrants &&
                                touched?.recurringGrants?.[keyIndex] &&
                                !values?.recurringGrants?.[keyIndex]
                                  ?.recurringFrequency) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringGrants?.[keyIndex]
                                ?.recurringFrequency &&
                              errors?.recurringGrants?.[keyIndex]
                                ?.recurringFrequency
                                ? errors?.recurringGrants?.[keyIndex]
                                    ?.recurringFrequency
                                : "Select Recurring Frequency"
                            }
                          />
                          <SelectField
                            name={`recurringGrants[${keyIndex}].recurringFrequency`}
                            placeholder={" "}
                            value={
                              values.recurringGrants?.[keyIndex]
                                .recurringFrequency
                            }
                            isDisabled={isSubscribed}
                            handleChange={handleGrantsAndChargesRecurringFrequencyAndUsageOptions(
                              values.recurringGrants?.[keyIndex]
                                .recurringFrequency,
                              `recurringGrants[${keyIndex}].recurringFrequency`,
                              setFieldValue,
                              setFieldTouched
                            )}
                            options={recurringGrantFrequencyOptions}
                            isRVStyle={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6} lg={6} xxl={3}>
                        <FormGroup>
                          <Label
                            htmlFor={`recurringGrants[${keyIndex}].recurringFrequencyUnit`}
                          >
                            Recurring Frequency Unit
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].recurringFrequencyUnit`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringGrants &&
                                touched?.recurringGrants?.[keyIndex] &&
                                !values?.recurringGrants?.[keyIndex]
                                  ?.recurringFrequencyUnit) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringGrants?.[keyIndex]
                                ?.recurringFrequencyUnit &&
                              errors?.recurringGrants?.[keyIndex]
                                ?.recurringFrequencyUnit
                                ? errors?.recurringGrants?.[keyIndex]
                                    ?.recurringFrequencyUnit
                                : "Enter Recurring Frequency Unit"
                            }
                          />
                          <InputField
                            name={`recurringGrants[${keyIndex}].recurringFrequencyUnit`}
                            className="form-control"
                            type="number"
                            handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                              handleChange
                            )}
                            value={
                              values?.recurringGrants?.[keyIndex]
                                ?.recurringFrequencyUnit
                            }
                            invalid={
                              errors?.recurringGrants &&
                              errors?.recurringGrants?.[keyIndex] &&
                              touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              touched?.recurringGrants?.[keyIndex]
                                ?.recurringFrequencyUnit &&
                              errors?.recurringGrants?.[keyIndex]
                                ?.recurringFrequencyUnit
                                ? true
                                : false
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <Label
                          for={`recurringGrants[${keyIndex}].cycleAlignment`}
                        >
                          Cycle Alignment<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`recurringGrants[${keyIndex}].cycleAlignment`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              !values?.recurringGrants?.[keyIndex]
                                ?.cycleAlignment) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringGrants?.[keyIndex]
                              ?.cycleAlignment &&
                            errors?.recurringGrants?.[keyIndex]?.cycleAlignment
                              ? errors?.recurringGrants?.[keyIndex]
                                  ?.cycleAlignment
                              : "Select Cycle Alignment"
                          }
                        />
                        <SelectField
                          className={
                            touched?.recurringGrants &&
                            touched?.recurringGrants?.[keyIndex] &&
                            !values?.recurringGrants?.[keyIndex]?.cycleAlignment
                              ? "error-input"
                              : ""
                          }
                          name={`recurringGrants[${keyIndex}].cycleAlignment`}
                          placeholder={" "}
                          isDisabled={isSubscribed}
                          value={
                            values.recurringGrants?.[keyIndex].cycleAlignment
                          }
                          handleChange={(value) => {
                            setFieldValue(
                              `recurringGrants[${keyIndex}].cycleAlignment`,
                              value
                            );
                          }}
                          options={CycleAlignmentOption}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <FormGroup>
                          <Label
                            htmlFor={`recurringGrants[${keyIndex}].resourceType`}
                          >
                            Resource Type<span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].resourceType`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringGrants &&
                                touched?.recurringGrants?.[keyIndex] &&
                                !values?.recurringGrants?.[keyIndex]
                                  ?.resourceType) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringGrants?.[keyIndex]
                                ?.resourceType &&
                              errors?.recurringGrants?.[keyIndex]?.resourceType
                                ? errors?.recurringGrants?.[keyIndex]
                                    ?.resourceType
                                : "Select Resource Type"
                            }
                          />
                          <SelectField
                            className={
                              touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              !values?.recurringGrants?.[keyIndex].resourceType
                                ? "error-input"
                                : ""
                            }
                            name={`recurringGrants[${keyIndex}].resourceType`}
                            placeholder={" "}
                            isDisabled={isSubscribed}
                            value={
                              values?.recurringGrants?.[keyIndex]?.resourceType
                            }
                            handleChange={grantsAndChargesHandle(
                              `recurringGrants[${keyIndex}].resourceType`,
                              values?.recurringGrants?.[keyIndex],
                              setFieldValue,
                              setFieldTouched,
                              resourceData,
                              setDisableValidityInGrantRecurring,
                              keyIndex
                            )}
                            options={grantResourceOptions}
                            isRVStyle={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <FormGroup>
                          <Label
                            htmlFor={`recurringGrants[${keyIndex}].resourceValue`}
                          >
                            Resource Value
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].resourceValue`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.recurringGrants &&
                                touched?.recurringGrants?.[keyIndex] &&
                                !values?.recurringGrants?.[keyIndex]
                                  ?.resourceValue) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringGrants?.[keyIndex]
                                ?.resourceValue &&
                              errors?.recurringGrants?.[keyIndex]?.resourceValue
                                ? errors?.recurringGrants?.[keyIndex]
                                    ?.resourceValue
                                : "Enter Resource Value"
                            }
                          />
                          <InputField
                            name={`recurringGrants[${keyIndex}].resourceValue`}
                            className="form-control"
                            type="number"
                            handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                              handleChange
                            )}
                            value={
                              values.recurringGrants?.[keyIndex].resourceValue
                            }
                            invalid={
                              errors?.recurringGrants &&
                              errors?.recurringGrants?.[keyIndex] &&
                              touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              touched?.recurringGrants?.[keyIndex]
                                ?.resourceValue &&
                              errors?.recurringGrants?.[keyIndex]?.resourceValue
                                ? true
                                : false
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <FormGroup>
                          <Label>Type of Resource</Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].nonCurrency`}
                            classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                            displayText={"Non-Currency"}
                          />
                          <InputField
                            name={`recurringGrants[${keyIndex}].nonCurrency`}
                            className={` ${
                              isEdit ? "label-disable-color-edit-offer" : ""
                            }`}
                            value="Non-Currency"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      {values?.recurringGrants?.[keyIndex]?.infinite && (
                        <Col xs={12} md={6} lg={4} xxl={3}>
                          <FormGroup>
                            <Label
                              htmlFor={`recurringGrants[${keyIndex}].infinite`}
                            >
                              Infinite
                            </Label>
                            <LabelText
                              htmlFor={`recurringGrants[${keyIndex}].infinite`}
                              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                              displayText={"Select Infinite"}
                            />
                            <SelectField
                              name={`recurringGrants[${keyIndex}].infinite`}
                              placeholder={" "}
                              value={
                                values?.recurringGrants?.[keyIndex]?.infinite
                              }
                              isDisabled={isSubscribed}
                              handleChange={handleInfiniteForGrantsAndCharges(
                                `recurringGrants[${keyIndex}].infinite`,
                                values?.recurringGrants?.[keyIndex],
                                setFieldValue
                              )}
                              options={infiniteOptions}
                              isRVStyle={true}
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {values?.recurringGrants?.[keyIndex]?.ceiling ? (
                        <Col xs={12} md={6} lg={4} xxl={3}>
                          <FormGroup>
                            <Label
                              htmlFor={`recurringGrants[${keyIndex}].ceiling`}
                            >
                              Ceiling
                            </Label>
                            <LabelText
                              htmlFor={`recurringGrants[${keyIndex}].ceiling`}
                              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                              displayText={"Enter Ceiling"}
                            />
                            <InputField
                              name={`recurringGrants[${keyIndex}].ceiling`}
                              className={` ${
                                isEdit ? "label-disable-color-edit-offer" : ""
                              }`}
                              value={
                                values?.recurringGrants?.[keyIndex]?.ceiling
                              }
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      ) : null}
                      {values?.recurringGrants?.[keyIndex]?.floor ? (
                        <Col xs={12} md={6} lg={4} xxl={3}>
                          <FormGroup>
                            <Label
                              htmlFor={`recurringGrants[${keyIndex}].floor`}
                            >
                              Floor
                            </Label>
                            <LabelText
                              htmlFor={`recurringGrants[${keyIndex}].floor`}
                              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                              displayText={"Enter Floor"}
                            />
                            <InputField
                              name={`recurringGrants[${keyIndex}].floor`}
                              className={` ${
                                isEdit ? "label-disable-color-edit-offer" : ""
                              }`}
                              value={values?.recurringGrants?.[keyIndex]?.floor}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      ) : null}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mt-0">
                        <Label
                          for={`recurringGrants[${keyIndex}].validityStartsOn`}
                        >
                          Validity Starts<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`recurringGrants[${keyIndex}].validityStartsOn`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              !values?.recurringGrants?.[keyIndex]
                                ?.validityStartsOn &&
                              !disableValidityInGrantRecurring[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringGrants?.[keyIndex]
                              ?.validityStartsOn &&
                            errors?.recurringGrants?.[keyIndex]
                              ?.validityStartsOn
                              ? errors?.recurringGrants?.[keyIndex]
                                  ?.validityStartsOn
                              : "Select Validity Starts"
                          }
                        />
                        <SelectField
                          className={
                            touched?.recurringGrants &&
                            touched?.recurringGrants?.[keyIndex] &&
                            !values?.recurringGrants?.[keyIndex]
                              .validityStartsOn &&
                            !disableValidityInGrantRecurring[keyIndex]
                              ? "error-input"
                              : ""
                          }
                          name={`recurringGrants[${keyIndex}].validityStartsOn`}
                          placeholder={" "}
                          isDisabled={isSubscribed}
                          value={
                            values?.recurringGrants?.[keyIndex]
                              ?.validityStartsOn
                          }
                          handleChange={(value) => {
                            setFieldValue(
                              `recurringGrants[${keyIndex}].validityStartsOn`,
                              value
                            );
                          }}
                          options={ValidityStartsOnOptions}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3} className="mt-0">
                        <Label
                          for={`recurringGrants[${keyIndex}].validityEndsOn`}
                        >
                          Validity Ends<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`recurringGrants[${keyIndex}].validityEndsOn`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              !values?.recurringGrants?.[keyIndex]
                                ?.validityEndsOn &&
                              !disableValidityInGrantRecurring[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringGrants?.[keyIndex]
                              ?.validityEndsOn &&
                            errors?.recurringGrants?.[keyIndex]?.validityEndsOn
                              ? errors?.recurringGrants?.[keyIndex]
                                  ?.validityEndsOn
                              : "Select Validity Ends"
                          }
                        />
                        <FormGroup>
                          <SelectField
                            className={
                              touched?.recurringGrants &&
                              touched?.recurringGrants?.[keyIndex] &&
                              !values?.recurringGrants?.[keyIndex]
                                ?.validityEndsOn &&
                              !disableValidityInGrantRecurring[keyIndex]
                                ? "error-input"
                                : ""
                            }
                            name={`recurringGrants[${keyIndex}].validityEndsOn`}
                            placeholder={" "}
                            isDisabled={isSubscribed}
                            value={
                              values?.recurringGrants?.[keyIndex]
                                ?.validityEndsOn
                            }
                            handleChange={(value) => {
                              setFieldValue(
                                `recurringGrants[${keyIndex}].validityEndsOn`,
                                value
                              );
                            }}
                            options={GrantsValidityEnd.filter(
                              (_, idx) => idx !== 1
                            )}
                            isRVStyle={true}
                          />
                        </FormGroup>
                      </Col>
                      {values?.recurringGrants?.[keyIndex]?.validityEndsOn
                        ?.label === "Relative" && (
                        <>
                          <Col xs={12} md={6} lg={4} xxl={3} className="mb-2">
                            <Label>Time Period</Label>
                            <LabelText
                              htmlFor={`recurringGrants[${keyIndex}].grantValidityEndsOnTimeperiod`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                (touched?.recurringGrants &&
                                  touched?.recurringGrants?.[keyIndex] &&
                                  errors?.recurringGrants?.[keyIndex]
                                    ?.grantValidityEndsOnTimeperiod &&
                                  !disableValidityInGrantRecurring[keyIndex]) ||
                                false
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringGrants?.[keyIndex]
                                  ?.grantValidityEndsOnTimeperiod &&
                                errors?.recurringGrants?.[keyIndex]
                                  ?.grantValidityEndsOnTimeperiod
                                  ? errors?.recurringGrants?.[keyIndex]
                                      ?.grantValidityEndsOnTimeperiod
                                  : "Enter Time Period"
                              }
                            />
                            <InputField
                              name={`recurringGrants[${keyIndex}].grantValidityEndsOnTimeperiod`}
                              disabled={isSubscribed}
                              type="number"
                              className={`form-control ${
                                isSubscribed
                                  ? "label-disable-color-edit-offer"
                                  : ""
                              }`}
                              id="grantValidityEndsOnTimeperiod"
                              handleChange={handleChange}
                              value={
                                values?.recurringGrants?.[keyIndex]
                                  ?.grantValidityEndsOnTimeperiod
                              }
                            />
                          </Col>
                          <Col xs={12} md={6} lg={4} xxl={3} style={{ marginTop: "55px" }}>
                            <div data-testid="select-component">
                              <SelectField
                                name={`recurringGrants[${keyIndex}].grantValidityEndsOn`}
                                placeholder={" "}
                                isDisabled={isSubscribed}
                                value={
                                  values.recurringGrants?.[keyIndex]
                                    .grantValidityEndsOn || ""
                                }
                                handleChange={(val) => {
                                  values.recurringGrants[
                                    keyIndex
                                  ].grantValidityEndsOn = val;
                                  setFieldValue(
                                    `recurringGrants[${keyIndex}].grantValidityEndsOn`,
                                    val
                                  );
                                }}
                                options={TimePeriodGrantOptions}
                                isRVStyle={true}
                              />
                            </div>
                          </Col>
                        </>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <Label>Override</Label>
                        <LabelText
                          htmlFor={`recurringGrants[${keyIndex}].override`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enable / Disable Override"}
                        />
                        <FormGroup
                          switch
                          className="d-flex align-items-start switch-state"
                        >
                          <div className="me-2">
                            <Input
                              type="switch"
                              className="rv-form-switch-input"
                              disabled={isEdit}
                              checked={
                                values?.recurringGrants?.[keyIndex]?.override
                              }
                              onChange={() =>
                                handleGrantsRecurringOverride(
                                  keyIndex,
                                  values,
                                  setFieldValue
                                )
                              }
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <Label>Prorate</Label>
                        <LabelText
                          htmlFor={`recurringGrants[${keyIndex}].floor`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enable / Disable Prorate"}
                        />
                        <FormGroup
                          switch
                          className="d-flex align-items-start switch-state"
                        >
                          <div className="me-2">
                            <Input
                              type="switch"
                              className="rv-form-switch-input"
                              disabled={isEdit}
                              checked={
                                values?.recurringGrants?.[keyIndex]?.prorate
                              }
                              onChange={() =>
                                handleProrateState(
                                  keyIndex,
                                  values,
                                  setFieldValue
                                )
                              }
                            />
                          </div>
                          <div className="flex-column">
                            <Label
                              id="UncontrolledTooltipExample"
                              htmlFor="globalOffer"
                              className="text-danger"
                              displayText="Prorate"
                              check
                            />
                            <UncontrolledTooltip target="UncontrolledTooltipExample">
                              Enable rating user based on their service
                              consumption
                            </UncontrolledTooltip>
                          </div>
                        </FormGroup>
                      </Col>
                      <>
                        <Col xs={12} md={6} lg={4} xxl={3}>
                          <Label>Rollover</Label>
                          <LabelText
                            htmlFor={`recurringGrants[${keyIndex}].rollover`}
                            classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                            displayText={"Enable / Disable Rollover"}
                          />
                          <FormGroup
                            switch
                            className="d-flex align-items-start switch-state"
                          >
                            <div className="me-2">
                              <Input
                                type="switch"
                                className="rv-form-switch-input"
                                checked={
                                  values?.recurringGrants?.[keyIndex]?.rollover
                                }
                                onChange={() =>
                                  handleRolloverState(
                                    keyIndex,
                                    values,
                                    setFieldValue
                                  )
                                }
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        {values?.recurringGrants?.[keyIndex]?.rollover ? (
                          <>
                            <Col xs={12} md={6} lg={4} xxl={3}>
                              <Label>Rollover Priority</Label>
                              <LabelText
                                htmlFor={`recurringGrants[${keyIndex}].rolloverPriority`}
                                classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                                displayText={
                                  "Enable / Disable Rollover Priority"
                                }
                              />
                              <FormGroup
                                switch
                                className="d-flex align-items-start switch-state"
                              >
                                <div>
                                  <Input
                                    type="switch"
                                    className="rv-form-switch-input"
                                    checked={
                                      values?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverPriority
                                    }
                                    onChange={() =>
                                      handleRolloverPriorityState(
                                        keyIndex,
                                        values,
                                        setFieldValue
                                      )
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={4} xxl={3}>
                              <FormGroup>
                                <Label
                                  htmlFor={`recurringGrants[${keyIndex}].rolloverModel.rolloverAmount`}
                                >
                                  Maximum Rollover Amount
                                </Label>
                                <LabelText
                                  htmlFor={`recurringGrants[${keyIndex}].rolloverModel.rolloverAmount`}
                                  classLabelName={`d-block ms-0 rv-sub-label ${
                                    (touched?.recurringGrants &&
                                      touched?.recurringGrants?.[keyIndex] &&
                                      !values?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverAmount &&
                                      !disableValidityInGrantRecurring[
                                        keyIndex
                                      ]) ||
                                    false
                                      ? "rv-label-danger"
                                      : "rv-label-muted"
                                  } `}
                                  displayText={
                                    touched?.recurringGrants?.[keyIndex]
                                      ?.rolloverAmount &&
                                    errors?.recurringGrants?.[keyIndex]
                                      ?.rolloverModel?.rolloverAmount
                                      ? errors?.recurringGrants?.[keyIndex]
                                          ?.rolloverModel?.rolloverAmount
                                      : "Enter Maximum Rollover Amount"
                                  }
                                />
                                {values?.recurringGrants?.[keyIndex]
                                  ?.rollover && (
                                  <InputField
                                    name={`recurringGrants[${keyIndex}].rolloverModel.rolloverAmount`}
                                    className="form-control"
                                    placeholder="Enter Rollover Amount"
                                    type="number"
                                    handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                                      handleChange
                                    )}
                                    value={
                                      values?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverAmount
                                    }
                                    invalid={
                                      errors?.recurringGrants &&
                                      errors?.recurringGrants?.[keyIndex] &&
                                      touched?.recurringGrants &&
                                      touched?.recurringGrants?.[keyIndex] &&
                                      touched?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverAmount &&
                                      errors?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverAmount
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                              </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={4} xxl={3}>
                              <FormGroup>
                                <Label
                                  htmlFor={`recurringGrants[${keyIndex}].rolloverModel.rolloverCycle`}
                                >
                                  Maximum Rollover Cycle
                                </Label>
                                <LabelText
                                  htmlFor={`recurringGrants[${keyIndex}].rolloverModel.rolloverCycle`}
                                  classLabelName={`d-block ms-0 rv-sub-label ${
                                    (touched?.recurringGrants &&
                                      touched?.recurringGrants?.[keyIndex] &&
                                      !values?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel.rolloverCycle &&
                                      !disableValidityInGrantRecurring[
                                        keyIndex
                                      ]) ||
                                    false
                                      ? "rv-label-danger"
                                      : "rv-label-muted"
                                  } `}
                                  displayText={
                                    touched?.recurringGrants?.[keyIndex]
                                      ?.rolloverModel?.rolloverCycle &&
                                    errors?.recurringGrants?.[keyIndex]
                                      ?.rolloverModel?.rolloverCycle
                                      ? errors?.recurringGrants?.[keyIndex]
                                          ?.rolloverModel?.rolloverCycle
                                      : "Enter Maximum Rollover Cycle"
                                  }
                                />
                                {values?.recurringGrants?.[keyIndex]
                                  ?.rolloverModel && (
                                  <InputField
                                    name={`recurringGrants[${keyIndex}].rolloverModel.rolloverCycle`}
                                    className="form-control"
                                    placeholder="Enter Rollover Cycle"
                                    type="number"
                                    handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                                      handleChange
                                    )}
                                    value={
                                      values?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverCycle
                                    }
                                    invalid={
                                      errors?.recurringGrants &&
                                      errors?.recurringGrants?.[keyIndex] &&
                                      touched?.recurringGrants &&
                                      touched?.recurringGrants?.[keyIndex] &&
                                      touched?.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverCycle &&
                                      errors.recurringGrants?.[keyIndex]
                                        ?.rolloverModel?.rolloverCycle
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                              </FormGroup>
                            </Col>
                          </>
                        ) : null}
                      </>
                    </Row>
                  </div>
                );
              })
            )}
          </div>
        );
      }}
    </FieldArray>
  );
}
